export default __webpack_public_path__ + "static/media/cloud-computing.551af671.svg";